'use strict';

module.exports = exports = require('./naiveBayes').NaiveBayes;
exports.separateClasses = require('./naiveBayes').separateClasses;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-naivebayes/src/index.js
 ** module id = 136
 ** module chunks = 0
 **/